import { fetchData, getApi } from '@/lib/api.service.js'

const currentUrl = `${import.meta.env.VITE_BACKEND_URL}/api/v2/service_providers`;

export async function indexServiceProviders(params = null) {
  try {
    return await fetchData(currentUrl, params);
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function getServiceProvider(id){
  try {
    let url = `${currentUrl}/${id}`;
    const response = await getApi(url);

    if (response.status >= 200 && response.status < 300) {
      return response.json
    } else {
      throw new Error(response.json.error);
    }
  } catch (e) {
    console.error(e);
    throw e;
  }
}

export async function getServiceProviderHours(id){
    try {
        let url = `${currentUrl}/${id}/get_hours`;
        const response = await getApi(url);

        if (response.status >= 200 && response.status < 300) {
            return response.json
        } else {
            throw new Error(response.json.error);
        }
    } catch (e) {
        console.error(e);
        throw e;
    }
}